import React from "react";
import platform from "Pub/js/platform";
import { langCheck } from "Pub/js/utils";
const { base } = platform;
const { NCTooltip } = base;
class GroupSwitch extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="group-switch-container iconContainer" title={this.props.groupName} 
                onClick={this.props.onClick}
            >
            <NCTooltip
                placement='bottom'
                overlay={langCheck("0000PUB-000366")}
                trigger='hover'
                delayShow={500}
                delay={1}
                mouseLeaveDelay={0}
            >
                <i className="iconfont icon-zuzhi3" />
            </NCTooltip>
            </div>
        );
    }
}
export default GroupSwitch;
